<script lang="ts">
    export let size = 13;

    const viewBox = `0 0 ${size} ${size}`;
</script>

<svg width={size} height={size} {viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5142 4.95323H8.10482L6.74919 0.894531L5.39373 4.95323H0.984375L4.55318 7.46896L3.19755 11.5277L6.76635 9.01193L8.9627 7.46896L12.5142 4.95323ZM6.74919 9.02869L9.25422 8.40814L10.301 11.5612L6.74919 9.02869Z"
        fill="white"
    />
</svg>
